import { createReducer, on } from '@ngrx/store';
import { resetSettings, updateUserSettings } from '../actions/settings.actions';
import { PathDistanceUnits, PathSpeedUnits } from '@app/modules/location/models/path-api.model';

export const settingsFeatureKey = 'settings';

export interface Settings {
  showVehicleSpeed: boolean;
  distanceUnit: string;
  speedUnit: string;
  dateFormat: string;
  assetViewType: string;
  elapsedTime: boolean;
}

export const initialSate: Settings = {
  showVehicleSpeed: false,
  distanceUnit: PathDistanceUnits.KM,
  speedUnit: PathSpeedUnits.KPH,
  dateFormat: 'dd/MM/yyyy',
  assetViewType: 'VRN',
  elapsedTime: false
};

export const reducer = createReducer(
  initialSate,

  on(
    updateUserSettings,
    (state, { showVehicleSpeed, distanceUnit, speedUnit, dateFormat, assetViewType, elapsedTime }) => {
      return { ...state, showVehicleSpeed, distanceUnit, speedUnit, dateFormat, assetViewType, elapsedTime };
    }
  ),
  on(resetSettings, () => {
    const serializedSate = JSON.stringify(initialSate);
    localStorage.setItem('userSettings', serializedSate);
    return initialSate;
  })
);
